/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '@/services/toast';
import countries from '@/services/country.json';
import allCountries from './phoneCodeList.json';
import { Datetime } from 'vue-datetime';
import { VueEditor } from "vue2-editor";
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import {
  mapGetters
} from 'vuex';
export default {
  name: 'interview-update',
  components: {
    datetime: Datetime,
    VueEditor
  },
  props: [],
  data () {
    return {
      submitted:false,
      fullName:'',
      email:'',
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      allCountriesList:[],
      countryList:[],
      interview_date:'',
      file:null,
      uploadAttachmentName:'',
      comment:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
      interviewInfo:null,
      new_interview_date:'',
      newDateBox:false,
      round_1:true,
      round_2:false,
      round_3:false,
      round_4:false,
      round_5:false,
      roundstep_2:false,
      roundstep_3:false,
      roundstep_4:false,
      roundstep_5:false,
      status:false
    }
  },
  computed: {
    ...mapGetters([
      'interviewInfoByIdGetters'
    ]),
    getInterviewInfoByIdFun() {
      this.interviewInfo = this.$store.getters.interviewInfoByIdGetters.data
      return
    },
    setIntialStates(){
      if(this.interviewInfo){
        this.fullName = this.interviewInfo.name
        this.email = this.interviewInfo.email
        this.interview_date = this.interviewInfo.interview_date
        this.uploadAttachmentName = this.interviewInfo.file_name
        this.round_1 = this.interviewInfo.round_1
        this.round_2 = this.interviewInfo.round_2
        this.round_3 = this.interviewInfo.round_3
        this.status = this.interviewInfo.status
        this.phone.countryCode = this.interviewInfo.mobile_country_code
        this.phone.number = this.interviewInfo.mobile
        this.comment = this.interviewInfo.comment
        setTimeout(()=>{
          if(this.phone.countryCode != null && this.phone.countryCode != ''){
            var countrySplit = this.phone.countryCode
            var phoneCountry = countrySplit.replace('+', '');
            this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
            }
        },100)
      }
      return
    }
  },
  mounted () {
    this.getInterviewInfoByIdFun
    this.setIntialStates
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    $('.option-list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.option-list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
  },
  methods: {
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          var formData = new FormData();
          formData.append('name', this.fullName);
          formData.append('email', this.email);
          formData.append('interview_date', this.interview_date);
          formData.append('file_name', this.uploadAttachmentName);
          formData.append('mobile_country_code', this.phone.countryCode);
          formData.append('mobile', this.phone.number);
          formData.append('comment', this.comment);
          formData.append('status', this.status);
          if(this.status){
            formData.append('is_completed', true);
          }
          if(this.file != null){
            formData.append('resume', this.file);
          }
          if(this.roundstep_2 === true){
            formData.append('round_2_datetime', this.new_interview_date);
            formData.append('round_2', true);
          }
          if(this.roundstep_3 === true){
            formData.append('round_3_datetime', this.new_interview_date);
            formData.append('round_3', true);
          }
          this.$store.dispatch('updateInterviewInfoByIDFun', { data:{ data:formData, id: this.$route.params.updateID}})
            .then((res) => {  
              toast.success(res.data.msg);      
              this.submitted = false;      
              this.$router.push({ name: 'employeeInterviewList'})
            }).catch((err) => {     
              this.submitted = false;  
              toast.error(err.data.user_msg || err.data.msg);
            })
            return;
        }
      });
    },
    clearUploadedFileForModelTrainerMethod(){
      this.file = null
      this.uploadAttachmentName = ''
    },
    handleAttachmentUpload(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }else {
        this.uploadAttachmentName = '';
      }
    },
  },
  watch:{
    getInterviewInfoByIdFun() {
      return this.$store.getters.interviewInfoByIdGetters
    },
    setIntialStates(){
      if(this.interviewInfo){
        this.fullName = this.interviewInfo.name
        this.email = this.interviewInfo.email
        this.interview_date = this.interviewInfo.interview_date
        this.uploadAttachmentName = this.interviewInfo.file_name
        this.phone.countryCode = this.interviewInfo.mobile_country_code
        this.phone.number = this.interviewInfo.mobile
        this.comment = this.interviewInfo.comment
        this.round_1 = this.interviewInfo.round_1
        this.round_2 = this.interviewInfo.round_2
        this.round_3 = this.interviewInfo.round_3 
        this.status = this.interviewInfo.status
        setTimeout(()=>{
          if(this.phone.countryCode != null && this.phone.countryCode != ''){
            var countrySplit = this.phone.countryCode
            var phoneCountry = countrySplit.replace('+', '');
            this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
            }
        },100)
      }
      return
    }
  }
}